module.exports = __webpack_public_path__ + "static/media/routeInfo.bf1a4516.svg";